import { InvalidEngagementStateStrategy } from './invalid-engaement-state-strategy.model';

export class DocumentSignedBySomeoneElseStrategyModel extends InvalidEngagementStateStrategy {

  constructor(hasAdditionalTasks: boolean, engagementId: number) {
    super(engagementId, hasAdditionalTasks);
  }

  getTitle() { return 'This document has already been signed by someone else.'; }
  getImagePath() { return 'already-signed.png'; }
}
